import { render, staticRenderFns } from "./AttachUserModal.vue?vue&type=template&id=10dc36b1&"
import script from "./AttachUserModal.vue?vue&type=script&lang=js&"
export * from "./AttachUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports